module.exports = __webpack_public_path__ + "img/iconZhong.24c6305a.png";